import { Box, CircularProgress } from '@mui/material';
import { ErrorOutlined, InsightsOutlined } from '@mui/icons-material';

import Result from 'components/v2/common/Result';

interface AnalyticsLoadingProps {
    minHeight?: number | string;
}

export function AnalyticsLoading({ minHeight = 240 }: AnalyticsLoadingProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight,
                py: 4,
            }}
        >
            <CircularProgress size={36} />
        </Box>
    );
}

interface AnalyticsErrorProps {
    message?: string;
    title?: string;
}

export function AnalyticsError({
    message = 'Failed to load analytics data. Please try again.',
    title = 'Unable to load data',
}: AnalyticsErrorProps) {
    return (
        <Result
            icon={<ErrorOutlined sx={{ fontSize: 32 }} />}
            title={title}
            description={message}
        />
    );
}

interface AnalyticsEmptyProps {
    title?: string;
    description?: string;
}

export function AnalyticsEmpty({
    title = 'No analytics data',
    description = 'There is nothing to show for the selected filters yet.',
}: AnalyticsEmptyProps) {
    return (
        <Result
            icon={<InsightsOutlined sx={{ fontSize: 32 }} />}
            title={title}
            description={description}
        />
    );
}

export default AnalyticsLoading;
